import axios from "axios";
import { Apis } from "constants/apis";
import { decrypt } from "utils/security";
import { getToken } from "utils/token";

const getManualInvoice = async () => {
    const { data } = await axios.get(Apis.GET_MANUAL_INVOICE, { headers: { Authorization: getToken() } })
    return decrypt(data?.data);
}

export default getManualInvoice